// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contacts_wrapper__39t7E","contact_info":"Contacts_contact_info__1mG8P"};